var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.4 21.8H2.6C2.17565 21.8 1.76869 21.6314 1.46863 21.3314C1.16857 21.0313 1 20.6243 1 20.2V12.2C1 11.3513 1.33714 10.5374 1.93726 9.93726C2.53737 9.33714 3.35131 9 4.2 9H23.4C24.2487 9 25.0626 9.33714 25.6627 9.93726C26.2629 10.5374 26.6 11.3513 26.6 12.2V20.2C26.6 20.6243 26.4314 21.0313 26.1314 21.3314C25.8313 21.6314 25.4243 21.8 25 21.8H20.2M7.4 1H20.2V9H7.4V1ZM7.4 18.6H20.2V25H7.4V18.6Z",
    stroke: "#1B224C",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.0307e3d4434c2dfae29fb020409ac1e4.svg";
export { ForwardRef as ReactComponent };